import { PublicKey } from '@solana/web3.js';
import BN from 'bn.js';

export const mints = {
  ammo: new PublicKey('ammoK8AkX2wnebQb35cDAZtTkvsXQbi82cGeTnUvvfK'),
  bSol: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
  jitoSol: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
  uxd: new PublicKey('7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT'),
  atlas: new PublicKey('ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx'),
  bonk: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
  ethWormhole: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
  food: new PublicKey('foodQJAztMzX1DKpLaiounNe2BDMds5RNuPC6jsNrDG'),
  fuel: new PublicKey('fueL3hBZjLLLJHiFH9cqZoozTG3XQZ53diwFPwbzNim'),
  mSol: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
  polis: new PublicKey('poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk'),
  ray: new PublicKey('4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R'),
  srm: new PublicKey('SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt'),
  stSol: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
  tier1: new PublicKey('tr1HUaLpPmvaj1PAAXJokJ7PLjEGoSfuULhRvVvAPBS'),
  tier2: new PublicKey('tr2cweq4j6F8LrXk6vWWmamsxzkSFxyStCS3v1z2j75'),
  tier3: new PublicKey('tr3Z8EqLMeNf2gHSpCsu9uP2o5DzoQ8QNFmueKjHQ95'),
  toolkit: new PublicKey('tooLsNYLiVqzg8o4m3L2Uetbn62mvMWRqkog6PQeYKL'),
  usdc: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
  usdcWormhole: new PublicKey('A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM'),
  usdcDevnet: new PublicKey('Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr'),
  usdt: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'),
  wSol: new PublicKey('So11111111111111111111111111111111111111112'),
  arco: new PublicKey('ARCoQ9dndpg6wE2rRexzfwgJR3NoWWhpcww3xQcQLukg'),
  biomass: new PublicKey('MASS9GqtJz6ABisAxcUn3FeR4phMqH1XfG6LPKJePog'),
  carbon: new PublicKey('CARBWKWvxEuMcq3MqCxYfi7UoFVpL9c4rsQS99tw6i4X'),
  diamond: new PublicKey('DMNDKqygEN3WXKVrAD4ofkYBc4CKNRhFUbXP4VK7a944'),
  hydrogen: new PublicKey('HYDR4EPHJcDPcaLYUcNCtrXUdt1PnaN4MvE655pevBYp'),
  ironOre: new PublicKey('FeorejFjRRAfusN9Fg3WjEZ1dRCf74o6xwT5vDt3R34J'),
  copperOre: new PublicKey('CUore1tNkiubxSwDEtLc3Ybs1xfWLs8uGjyydUYZ25xc'),
  lumanite: new PublicKey('LUMACqD5LaKjs1AeuJYToybasTXoYQ7YkxJEc4jowNj'),
  rochinol: new PublicKey('RCH1Zhg4zcSSQK8rw2s6rDMVsgBEWa4kiv1oLFndrN5'),
  sdu: new PublicKey('SDUsgfSZaDhhZ76U3ZgvtFiXsfnHbf2VrzYxjBZ5YbM'),
  crystalLattice: new PublicKey('CRYSNnUd7cZvVfrEVtVNKmXiCPYdZ1S5pM5qG2FDVZHF'),
  copperWire: new PublicKey('cwirGHLB2heKjCeTy4Mbp4M443fU4V7vy2JouvYbZna'),
  copper: new PublicKey('CPPRam7wKuBkYzN5zCffgNU17RKaeMEns4ZD83BqBVNR'),
  electronics: new PublicKey('ELECrjC8m9GxCqcm4XCNpFvkS8fHStAvymS6MJbe3XLZ'),
  graphene: new PublicKey('GRAPHKGoKtXtdPBx17h6fWopdT5tLjfAP8cDJ1SvvDn4'),
  hydrocarbon: new PublicKey('HYCBuSWCJ5ZEyANexU94y1BaBPtAX2kzBgGD2vES2t6M'),
  iron: new PublicKey('ironxrUhTEaBiR9Pgp6hy4qWx6V2FirDoXhsFP25GFP'),
  magnet: new PublicKey('MAGNMDeDJLvGAnriBvzWruZHfXNwWHhxnoNF75AQYM5'),
  polymer: new PublicKey('PoLYs2hbRt5iDibrkPT9e6xWuhSS45yZji5ChgJBvcB'),
  steel: new PublicKey('STEELXLJ8nfJy3P4aNuGxyNRbWPohqHSwxY75NsJRGG'),
  energySubstrate: new PublicKey('SUBSVX9LYiPrzHeg2bZrqFSDSKkrQkiCesr6SjtdHaX'),
  electromagnet: new PublicKey('EMAGoQSP89CJV5focVjrpEuE4CeqJ4k1DouQW7gUu7yX'),
  framework: new PublicKey('FMWKb7YJA5upZHbu5FjVRRoxdDw2FYFAu284VqUGF9C2'),
  particleAccelerator: new PublicKey(
    'PTCLSWbwZ3mqZqHAporphY2ofio8acsastaHfoP87Dc'
  ),
  powerSource: new PublicKey('PoWRYJnw3YDSyXgNtN3mQ3TKUMoUSsLAbvE8Ejade3u'),
  radiationAbsorber: new PublicKey(
    'RABSXX6RcqJ1L5qsGY64j91pmbQVbsYRQuw1mmxhxFe'
  ),
  strangeEmitter: new PublicKey('EMiTWSLgjDVkBbLFaMcGU6QqFWzX9JX6kqs1UtUjsmJA'),
  superConductor: new PublicKey('CoNDDRCNxXAMGscCdejioDzb6XKxSzonbWb36wzSgp5T'),
  goldenTicket: new PublicKey('GLDTKDYdSkdCzSC6fqRWqHZ5fUQGsm1CM4nMZnsCZNcX'),
} as const;

export const mintsDecimals = {
  ammo: new BN(0),
  atlas: new BN(8),
  food: new BN(0),
  fuel: new BN(0),
  polis: new BN(8),
  tier1: new BN(0),
  tier2: new BN(0),
  tier3: new BN(0),
  toolkit: new BN(0),
  usdc: new BN(6),
  usdcDevnet: new BN(6),
  usdt: new BN(6),
  wSol: new BN(9),
  arco: new BN(0),
  biomass: new BN(0),
  carbon: new BN(0),
  diamond: new BN(0),
  hydrogen: new BN(0),
  ironOre: new BN(0),
  copperOre: new BN(0),
  lumanite: new BN(0),
  rochinol: new BN(0),
  sdu: new BN(0),
  crystalLattice: new BN(0),
  copperWire: new BN(0),
  copper: new BN(0),
  electronics: new BN(0),
  graphene: new BN(0),
  hydrocarbon: new BN(0),
  iron: new BN(0),
  magnet: new BN(0),
  polymer: new BN(0),
  steel: new BN(0),
  energySubstrate: new BN(0),
  electromagnet: new BN(0),
  framework: new BN(0),
  particleAccelerator: new BN(0),
  powerSource: new BN(0),
  radiationAbsorber: new BN(0),
  strangeEmitter: new BN(0),
  superConductor: new BN(0),
  goldenTicket: new BN(0),
} as const;
